import buildUrl from "../utils/buildUrl";
import { baseUrl } from "./baseUrl";

export const getGlsTasksRoute = (searchParams) =>
  buildUrl({
    url: `${baseUrl}/invoices-export-api/gls-tasks/search`,
    searchParams,
  });
